<template>
  <svg
    width="14"
    height="10"
    viewBox="0 0 14 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3592_2413)">
      <path
        d="M12.3333 1L5 8.33333L1.66667 5"
        stroke="#6C6D84"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3592_2413">
        <rect
          width="14"
          height="10"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
